/**
 * SEC-FIX: Runtime Config Reader
 * Hallazgo SURA (Criticidad Alta): CREDENCIALES Y SECRETOS HARDCODEADOS EN BUNDLE JS
 *
 * Las variables sensibles ya NO se leen desde process.env (que se embebe en el bundle).
 * Se leen desde window.__APP_CONFIG__ que es cargado desde /config.js en runtime,
 * un archivo generado por el servidor en cada deploy con los valores reales.
 *
 * Variables que quedan en process.env (NO sensibles — solo feature flags y URLs públicas):
 *   REACT_APP_ENV, USE_STG, PUBLIC_URL, REACT_APP_BASE_URL*, feature flags (REACT_APP_*)
 *
 * Variables movidas a runtime (sensibles — NO deben estar en el bundle):
 *   API_KEY, API_KEY_GATEWAY, OP_ID, OP_API_KEY, PUSHER_API_KEY, SEGMENT_KEY
 */
'use strict';

/**
 * Lee una variable sensible desde runtime config.
 * Falla de forma segura (undefined) si el config no fue cargado — NO expone fallback hardcodeado.
 */
function getRuntimeConfig(key) {
  if (typeof window === 'undefined') return undefined;
  const config = window.__APP_CONFIG__;
  if (!config) {
    console.error(
      '[SEC] window.__APP_CONFIG__ no está disponible. ' +
      'El servidor debe servir /config.js antes del bundle. ' +
      'Revisa que public/config.js sea generado en el deploy.'
    );
    return undefined;
  }
  const value = config[key];
  // Detectar placeholders no reemplazados (indica deploy mal configurado)
  if (typeof value === 'string' && value.startsWith('__RUNTIME_') && value.endsWith('__')) {
    console.error(`[SEC] El placeholder ${value} para '${key}' no fue reemplazado en el deploy.`);
    return undefined;
  }
  return value;
}

// Exporta cada secret como getter lazy (se lee en runtime, no en bundle-time)
const runtimeConfig = {
  get API_KEY()         { return getRuntimeConfig('API_KEY'); },
  get API_KEY_GATEWAY() { return getRuntimeConfig('API_KEY_GATEWAY'); },
  get CLIENT_KEY()      { return getRuntimeConfig('CLIENT_KEY'); },
  get OP_ID()           { return getRuntimeConfig('OP_ID'); },
  get OP_API_KEY()      { return getRuntimeConfig('OP_API_KEY'); },
  get OP_SANDBOX()      { return getRuntimeConfig('OP_SANDBOX'); },
  get PUSHER_API_KEY()  { return getRuntimeConfig('PUSHER_API_KEY'); },
  get SEGMENT_KEY()     { return getRuntimeConfig('SEGMENT_KEY'); },
};

module.exports = runtimeConfig;



// WEBPACK FOOTER //
// ./src/config/runtimeConfig.js